export default "__VITE_ASSET__P0gm7BBk__"